/* Mobile controls are proxies: Shopify's original multipart form owns the order. */
(() => {
  'use strict';
  if (window.CasituMobilePurchase) { window.CasituMobilePurchase.init(document); return; }
  const instances = new Map();
  function create(root) {
    const template = root.querySelector('[data-mobile-purchase-template]');
    const form = root.querySelector('form.product-form');
    const originalSubmit = form?.querySelector('[data-product-submit]');
    const originalQuantity = form?.querySelector('[name="quantity"]');
    if (!template || !originalSubmit || !originalQuantity || instances.has(root)) return;
    const dock = template.content.firstElementChild.cloneNode(true);
    const q = selector => dock.querySelector(selector);
    const box = form.querySelector('[data-box-toggle]');
    const boxArea = form.querySelector('[data-box-customizer]');
    const boxProxy = q('[data-dock-box]');
    const edit = q('[data-dock-edit]');
    const quantity = q('[data-dock-quantity]');
    const submit = q('[data-dock-submit]');
    const submitText = q('[data-dock-submit-text]');
    const total = q('[data-dock-total]');
    const status = q('[data-dock-status]');
    const media = matchMedia('(max-width: 749px)');
    const formatter = new Intl.NumberFormat(document.documentElement.lang || 'es', { style: 'currency', currency: root.dataset.productCurrency || 'EUR' });
    const disposers = [];
    let frame = 0, destroyed = false, preview = null;
    document.body.append(dock);
    function listen(target, event, handler, options) {
      if (!target) return;
      target.addEventListener(event, handler, options);
      disposers.push(() => target.removeEventListener(event, handler, options));
    }
    function updateText(element, text) { if (element.textContent !== text) element.textContent = text; }
    function measure() {
      frame = 0;
      if (destroyed) return;
      const candidate = document.getElementById('PBarNextFrameWrapper');
      if (candidate !== preview) {
        if (preview) resize?.unobserve(preview);
        previewObserver.disconnect();
        preview = candidate;
        if (preview) { resize?.observe(preview); previewObserver.observe(preview, {attributes:true,attributeFilter:['style','class','hidden']}); }
      }
      let offset = 0;
      if (preview) {
        const rect = preview.getBoundingClientRect(), style = getComputedStyle(preview);
        if (style.display !== 'none' && style.visibility !== 'hidden' && rect.height < innerHeight / 2 && Math.abs(rect.bottom - innerHeight) < 3) offset = Math.ceil(rect.height);
      }
      const active = document.activeElement;
      const keyboard = window.visualViewport && window.visualViewport.height < innerHeight * .72 &&
        active?.matches('input:not([type="checkbox"]):not([type="radio"]),textarea,[contenteditable="true"]') && !dock.contains(active);
      dock.toggleAttribute('data-keyboard-hidden', !!keyboard);
      const bottom = offset + 'px';
      if (dock.style.getPropertyValue('--mobile-purchase-preview') !== bottom) dock.style.setProperty('--mobile-purchase-preview', bottom);
      const height = Math.ceil(dock.getBoundingClientRect().height);
      if (height) {
        const space = (height + offset) + 'px';
        if (document.body.style.getPropertyValue('--mobile-purchase-space') !== space) document.body.style.setProperty('--mobile-purchase-space', space);
      }
    }
    function scheduleMeasure() { if (!frame && !destroyed) frame = requestAnimationFrame(measure); }
    const resize = typeof ResizeObserver === 'function' ? new ResizeObserver(scheduleMeasure) : null;
    const previewObserver = new MutationObserver(scheduleMeasure);
    const addedNodes = new MutationObserver(scheduleMeasure);
    addedNodes.observe(document.body, {childList:true});
    resize?.observe(dock);
    function sync() {
      if (destroyed) return;
      if (document.activeElement !== quantity) quantity.value = originalQuantity.value;
      ['min','max','step'].forEach(name => {
        if (originalQuantity.hasAttribute(name)) quantity.setAttribute(name, originalQuantity.getAttribute(name));
        else quantity.removeAttribute(name);
      });
      const selected = form.querySelector('[data-variant-select]')?.selectedOptions[0];
      const addonCents = box?.checked && !box.disabled ? Number(root.dataset.boxAddonPriceCents || 0) : 0;
      const cents = Number(selected?.dataset.priceCents ?? root.dataset.priceCents) + addonCents;
      const count = Math.max(1, Number(originalQuantity.value) || 1);
      updateText(total, formatter.format(cents * count / 100));
      total.setAttribute('aria-label', 'Total: ' + formatter.format(cents * count / 100));
      const busy = originalSubmit.getAttribute('aria-busy') === 'true';
      submit.disabled = originalSubmit.disabled || busy;
      submit.setAttribute('aria-busy', String(busy));
      updateText(submitText, originalSubmit.textContent.trim());
      quantity.disabled = busy;
      q('[data-dock-minus]').disabled = busy || count <= Number(originalQuantity.min || 1);
      q('[data-dock-plus]').disabled = busy || (!!originalQuantity.max && count >= Number(originalQuantity.max));
      if (box && boxProxy) {
        boxProxy.checked = box.checked;
        boxProxy.disabled = box.disabled || busy;
        edit.hidden = !box.checked;
        edit.disabled = busy;
        const custom = form.querySelector('[data-box-mode]:checked');
        updateText(edit, custom?.dataset.boxMode === 'default' ? 'Caja prediseñada · Cambiar diseño ↗' : 'Personalizar mi caja ↗');
      }
      scheduleMeasure();
    }
    function changeQuantity(value) {
      let number = Number(value);
      if (!Number.isFinite(number)) number = Number(originalQuantity.min || 1);
      number = Math.max(Number(originalQuantity.min || 1), Math.round(number));
      if (originalQuantity.max) number = Math.min(number, Number(originalQuantity.max));
      originalQuantity.value = String(number);
      quantity.value = String(number);
      originalQuantity.dispatchEvent(new Event('change', {bubbles:true}));
      sync();
    }
    function revealBox() {
      if (!boxArea) return;
      root.productPurchase?.revealBox();
      const target = boxArea.querySelector('[data-box-mode]:checked') || boxArea.querySelector('[data-box-editor-open]');
      const anchor = target?.closest('[data-box-mode-selector]') || target || boxArea;
      anchor.scrollIntoView({block:'center', behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      target?.focus({preventScroll:true});
    }
    listen(boxProxy, 'change', () => {
      if (!box) return;
      box.checked = boxProxy.checked;
      box.dispatchEvent(new Event('change', {bubbles:true}));
      sync();
      updateText(status, (box.checked ? 'Caja añadida. ' : 'Caja retirada. ') + 'Total: ' + total.textContent);
      if (box.checked && !form.querySelector('[data-box-mode="default"]')) revealBox();
    });
    listen(edit, 'click', revealBox);
    listen(quantity, 'input', () => { if (quantity.value !== '') changeQuantity(quantity.value); });
    listen(quantity, 'change', () => changeQuantity(quantity.value));
    listen(quantity, 'blur', () => changeQuantity(quantity.value));
    listen(q('[data-dock-minus]'), 'click', () => changeQuantity(Number(originalQuantity.value) - Number(originalQuantity.step || 1)));
    listen(q('[data-dock-plus]'), 'click', () => changeQuantity(Number(originalQuantity.value) + Number(originalQuantity.step || 1)));
    listen(submit, 'click', () => {
      if (submit.disabled) return;
      changeQuantity(quantity.value);
      if (root.productPurchase) root.productPurchase.request();
      else form.requestSubmit(originalSubmit);
    });
    listen(form, 'change', () => queueMicrotask(sync));
    listen(form, 'input', () => queueMicrotask(sync));
    listen(form, 'box:saved', sync);
    const observer = new MutationObserver(sync);
    observer.observe(originalSubmit, {childList:true,subtree:true,characterData:true,attributes:true,attributeFilter:['disabled','aria-busy']});
    function updateMedia() {
      dock.hidden = !media.matches;
      document.body.classList.toggle('has-mobile-purchase', media.matches);
      sync();
    }
    listen(media, 'change', updateMedia);
    listen(window, 'resize', scheduleMeasure, {passive:true});
    listen(window.visualViewport, 'resize', scheduleMeasure, {passive:true});
    listen(document, 'focusin', scheduleMeasure);
    listen(document, 'focusout', scheduleMeasure);
    listen(window, 'pageshow', () => { originalSubmit.removeAttribute('aria-busy'); originalSubmit.textContent = originalSubmit.disabled ? originalSubmit.dataset.soldOutText : originalSubmit.dataset.availableText; sync(); });
    updateMedia();
    instances.set(root, () => {
      destroyed = true;
      if (frame) cancelAnimationFrame(frame);
      disposers.forEach(dispose => dispose());
      observer.disconnect();resize?.disconnect();previewObserver.disconnect();addedNodes.disconnect();
      dock.remove();document.body.classList.remove('has-mobile-purchase');document.body.style.removeProperty('--mobile-purchase-space');
      instances.delete(root);
    });
  }
  function init(scope) { scope.querySelectorAll('[data-product-form]').forEach(create); }
  window.CasituMobilePurchase = {init};
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document)); else init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => { instances.forEach((destroy, root) => {if(event.target.contains(root))destroy();}); });
})();
